import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import { UB_RECIPIENTS_IMG } from "@/constants/campaignBuilder";
import UnboxingCtaButton from "./UnboxingCtaButton";

export interface UnboxingIntroLayoutProps {
  isMobile: boolean;
  headline: string;
  showGiftMessageButton: boolean;
  onUnwrap: () => void;
  onReadMessage: () => void;
  /** Toggling false→true restarts all CSS animations from the beginning. */
  visible: boolean;
}

export default function UnboxingIntroLayout({
  isMobile,
  headline,
  showGiftMessageButton,
  onUnwrap,
  onReadMessage,
  visible,
}: UnboxingIntroLayoutProps) {
  return (
    <div
      className={isMobile ? "flex flex-col" : "grid"}
      style={
        isMobile ? { gap: 18 } : { gridTemplateColumns: "340px 1fr", gap: 36, alignItems: "start" }
      }
    >
      <img
        src={UB_RECIPIENTS_IMG}
        alt="Gift collection"
        className={visible ? "animate-ub-img" : "opacity-0"}
        style={{
          // Mobile: centered square medallion capped at 40dvh (giftUnboxing.css .gub-img).
          width: isMobile ? "min(100%, 40dvh)" : 340,
          height: isMobile ? "auto" : 340,
          aspectRatio: isMobile ? "1 / 1" : undefined,
          margin: isMobile ? "0 auto" : undefined,
          objectFit: "cover",
          borderRadius: 12,
          display: "block",
        }}
      />

      <div
        className="flex flex-col"
        style={{
          gap: 16,
          alignItems: "flex-start",
          textAlign: "left",
          minWidth: 0,
        }}
      >
        <div
          className={visible ? "animate-ub-headline" : "opacity-0"}
          style={{
            fontFamily: "var(--font-crimson)",
            fontWeight: 400,
            fontSize: isMobile ? 28 : 30,
            color: "var(--color-rodeo-black)",
            lineHeight: 1.3,
          }}
        >
          {headline}
        </div>

        <div
          className={visible ? "animate-ub-body" : "opacity-0"}
          style={{
            fontFamily: "var(--font-lato)",
            fontSize: isMobile ? 17 : 18,
            fontWeight: 400,
            color: "var(--color-rodeo-black)",
            lineHeight: isMobile ? 1.65 : 1.8,
          }}
        >
          And every option does good in the world. Open your gift and choose the impact that matters
          most to you.
        </div>

        <div
          className={[
            isMobile ? "flex w-full flex-col items-stretch gap-2.5" : "flex items-center gap-3",
            visible ? "animate-ub-cta" : "opacity-0",
          ].join(" ")}
          style={{ marginTop: 16 }}
        >
          <UnboxingCtaButton
            variant="filled"
            icon={<CardGiftcardOutlinedIcon sx={{ fontSize: 18 }} />}
            onClick={onUnwrap}
            isMobile={isMobile}
          >
            Unwrap
          </UnboxingCtaButton>
          {showGiftMessageButton && (
            <UnboxingCtaButton
              variant="clear"
              icon={<MarkEmailReadOutlinedIcon sx={{ fontSize: 18 }} />}
              onClick={onReadMessage}
              isMobile={isMobile}
            >
              Read Message
            </UnboxingCtaButton>
          )}
        </div>
      </div>
    </div>
  );
}
